import { ContentType, ModalConstants, PagePart, Step } from 'app/modules/step-engine/utils/step-engine-constants';
import { lowerCase } from 'lodash';
import { cmsApi } from '../api/cms-api';
import { Avatars, CmsContentType, CmsPageContentType } from '../utils/cms-constants';
import { CmsContentTypeMap, CmsModalContentMap, CmsPageContentMap, CmsPagePartMap, itemsMapper } from '../utils/cms-mappers';
import { addPrismicContent, loadAvatar } from './store/cms-dispatchs';

export const loadContent = (itemKey: any, cmsKey: CmsPageContentType, contentType: ContentType = undefined) => async (
  dispatch,
  getState
) => {
  const { subscription } = getState().kubrickManagement;
  try {
    if (cmsKey !== undefined) {
      const cmsContentType: CmsContentType = contentType ? CmsContentTypeMap.get(contentType) : undefined;
      const response = await cmsApi.getPageContentFromCms(cmsKey, cmsContentType);

      if (response.data) {
        // Format CMS Items
        let { items, itemsDesktop, subItems } = response.data || {};
        if (subItems) {
          response.data.subItems = subItems = itemsMapper(itemKey, subItems);
        }
        if (itemsDesktop) {
          response.data.itemsDesktop = itemsDesktop = itemsMapper(itemKey, itemsDesktop);
        }
        if (items) {
          response.data.items = items = itemsMapper(itemKey, items);
          if (itemKey === Step.CHOOSE_DAMAGED_GOODS) {
            const insuredGoods = subscription.insuredGoods;
            response.data.items = response.data.items.filter(i => insuredGoods.find(ig => ig?.type?.code === i.code));
            const insuredGoodsEntities = {};
            items.forEach(element => {
              insuredGoodsEntities[element.code] = element.label;
            });
            response.data.insuredGoodsEntities = insuredGoodsEntities;
          }
        }
        const prismicContentKey = contentType ? contentType : itemKey;
        await dispatch(addPrismicContent(prismicContentKey, response.data));
      }
    }
  } catch (error) {
    // TODO
    // Manage errors
  }
};

export const loadPageContent = (stepKey: Step) => async dispatch => {
  if (CmsPageContentMap.has(stepKey)) {
    const cmsKey: CmsPageContentType = CmsPageContentMap.get(stepKey);
    await dispatch(loadContent(stepKey, cmsKey));
  }
};

export const loadModalContent = (modalKey: ModalConstants) => async dispatch => {
  const cmsKey: CmsPageContentType = CmsModalContentMap.get(modalKey);
  await dispatch(loadContent(modalKey, cmsKey));
};

export const loadAppContent = (pageKey: PagePart, contentType: ContentType = undefined) => async dispatch => {
  const cmsKey: CmsPageContentType = CmsPagePartMap.get(pageKey);
  await dispatch(loadContent(pageKey, cmsKey, contentType));
};

export const setStylesProperties = (data: any): any => {
  document.documentElement.style.setProperty('--active-field-background-color', data.activeFieldBackgroundColor);
  document.documentElement.style.setProperty('--active-item-background-color', data.primaryColor + '30');
  document.documentElement.style.setProperty('--background-color', data.backgroundColor);
  document.documentElement.style.setProperty('--background', 'url(' + data.backgroundImage + ') no-repeat top center');
  document.documentElement.style.setProperty('--background-image', 'url(' + data.backgroundImage + ')');
  document.documentElement.style.setProperty('--main-logo', 'url(' + data.mainLogo + ') no-repeat top center');
  document.documentElement.style.setProperty('--clickable-color', '#0092D4'); // TODO : data.clickableColor
  document.documentElement.style.setProperty('--fail-color', data.failColor);
  document.documentElement.style.setProperty('--field-information-color', data.fieldInformationColor);
  document.documentElement.style.setProperty('--form-background-color', data.formBackgroundColor);
  document.documentElement.style.setProperty('--hover-main-clickable-color', data.hoverMainClickableColor);
  document.documentElement.style.setProperty('--hover-secondary-clickable-color', data.hoverSecondaryClickableColor);
  document.documentElement.style.setProperty('--information-color', data.informationColor);
  document.documentElement.style.setProperty('--primary-color', data.primaryColor);
  document.documentElement.style.setProperty('--success-color', data.successColor);
  document.documentElement.style.setProperty('--text-color', data.textColor);
  document.documentElement.style.setProperty('--warning-color', data.warningColor);
  document.documentElement.style.setProperty('--panel-opened-color', data.panelOpenedColor);
  document.documentElement.style.setProperty('--background-layout-container-image', 'url(' + data.backgroundLayoutContainerImage + ')');
  document.documentElement.style.setProperty('--left-banner', 'url(' + data.leftImage + ')');
  document.documentElement.getElementsByClassName('customer-info-card')[0]?.setAttribute('widh', '100%');
};

export const updateAppStylesFromCms = appGlobalType => {
  setStylesProperties(appGlobalType);
};

export const getAvatar = () => dispatch => {
  const randomAvatarIndex = Math.floor(Math.random() * Avatars.length);
  const avatar = {
    photo: '/content/images/mobile-view/avatars/' + lowerCase(Avatars[randomAvatarIndex]?.name) + '.png',
    name: Avatars[randomAvatarIndex]?.name,
  };
  dispatch(loadAvatar(avatar));
};
